import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { UnorderedList } from '@r1-frontend/ui-react/components/List';

export const SpeedLineWithDescriptionWrapper = styled.div`
    display: flex;
    flex-direction: row;

    gap: 16px;

    & > * {
        width: 100%;
    }

    ${UnorderedList} {
        margin-top: 20px;
    }

    @media (min-width: ${wideBreakpoints.laptop}) {
        margin-top: 8px;
    }
`;

export const HeaderWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: baseline;
    margin-bottom: 8px;
    
    & > p {
        visibility: hidden;
    }
    
    @media (min-width: ${wideBreakpoints.mobile}) {
        margin-bottom: 12px;
        & > p {
            visibility: visible;
        }
    }
`;
